/* globals Charcoal, BootstrapDialog, commonL10n, $ */

const CONFIRM_DEFAULTS  = {
    supported: [ 'success', 'info', 'notice', 'warning', 'error', 'danger' ],
    definitions: {
        success: {
            title:   commonL10n.success,
            type:    BootstrapDialog.TYPE_SUCCESS
        },
        notice: {
            title:   commonL10n.notice,
            type:    BootstrapDialog.TYPE_INFO,
            alias:   [ 'info' ]
        },
        warning: {
            title:   commonL10n.warning,
            type:    BootstrapDialog.TYPE_WARNING
        },
        error: {
            title:   commonL10n.errorOccurred,
            type:    BootstrapDialog.TYPE_DANGER,
            alias:   [ 'danger' ]
        }
    },
    aliases: {
        info: 'notice',
        danger: 'error'
    }
}

/**
 * Property_Input_Widget_Button_Action
 *
 * - action_target : the target url of the action to fetch
 * - action_params : parameter to sends to the endpoint
 *
 *  This button widget allows to trigger a fetch request to any action endpoint using action_params as payload.
 *  The action_params can be defined by the property widget and is renderable using "renderable_data"
 *  In the case a confirmation is needed by the end-user, extend the {@see Charcoal\Admin\Action\Paj\AbstractConfirmableAction}
 *
 * @param opts
 * @constructor
 */
const Property_Input_Widget_Button_Action = function (opts) {
    Charcoal.Admin.Property.call(this, opts)

    this.input_id = '';
    this.action_target = null;
    this.action_params = null;

    this.set_properties(opts)

    if (!this.action_target) {
        throw new Error('Action target is not defined for ' + this.class);
    }

    this.element().on('click', () => this.process_action())
};

Property_Input_Widget_Button_Action.prototype = Object.create(Charcoal.Admin.Property.prototype);
Property_Input_Widget_Button_Action.prototype.constructor = Property_Input_Widget_Button_Action;
Property_Input_Widget_Button_Action.prototype.parent = Charcoal.Admin.Property.prototype;

Property_Input_Widget_Button_Action.prototype.set_properties = function (opts) {
    this.input_id = opts.id || this.input_id;
    this.action_target = opts.data.action_target || this.action_target;
    this.action_params = opts.data.action_params || this.action_params;

    return this;
};

Property_Input_Widget_Button_Action.prototype.process_action = async function (extra_data = {}) {
    const url = new URL(this.action_target, Charcoal.Admin.admin_url())
    const data = Object.assign({}, this.action_params, extra_data)

    const params = new URLSearchParams(data)
    url.search = params.toString()

    const response = await fetch(url)

    if (!response.ok) {
        Charcoal.Admin.feedback(response.status).dispatch();
    }

    const results = await response.json()

    if (!!results.confirmation) {
        this.confirm(results.confirmation, () => this.process_action({
            confirmed: true,
        }));

        return
    }

    if (results.feedbacks.length) {
        Charcoal.Admin.feedback(results.feedbacks).dispatch();
    }
}

/**
 * Load the widget into a dialog
 *
 * @param  {Object}   [dialog_opts]        - Dialog settings.
 * @param  {Function} [confirmed_callback] - What to do after the dialog is confirmed?
 * @param  {Function} [cancel_callback]    - What to do after the dialog is canceled?
 * @return {void}
 */
Property_Input_Widget_Button_Action.prototype.confirm = function (dialog_opts, confirmed_callback, cancel_callback) {
    const defaults = {
        type:     BootstrapDialog.TYPE_WARNING,
        callback: function (result) {
            if (result) {
                if (typeof confirmed_callback === 'function') {
                    confirmed_callback();
                }
            } else {
                if (typeof cancel_callback === 'function') {
                    cancel_callback();
                }
            }
        }
    };

    if (dialog_opts['type']) {
        let type = dialog_opts['type']
        delete dialog_opts['type']
        if (CONFIRM_DEFAULTS.supported.indexOf(type) === -1) {
            throw Error('Unsupported type ['+ type +'] for modal')
        }

        type = CONFIRM_DEFAULTS.aliases[type] || type;
        dialog_opts = $.extend(CONFIRM_DEFAULTS.definitions[type], dialog_opts);
    }

    const opts = $.extend(defaults, dialog_opts);

    BootstrapDialog.confirm(opts);
};

Charcoal.Admin.Property_Input_Widget_Button_Action = Property_Input_Widget_Button_Action;
